// extracted by mini-css-extract-plugin
module.exports = {"container":"Mission_container__FkY5L","missionContainer":"Mission_missionContainer__QRFnU","text":"Mission_text__UK_E_","missionCont":"Mission_missionCont__8Sfpv"};